import { useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";

import styles from "./ResultModalWindow.module.css";

export default function ResultModalWindow({
  show,
  setShow,
  result,
  appId,
  handleCloseApp,
  errorText = "",
  headerTextExternal,
  externalJSX,
  handleCloseExternal,
}) {
  const [headerText, setHeaderText] = useState("");
  const [messageText, setMessageText] = useState("");
  const path = window.location.pathname;

  useEffect(() => {
    debugger;
    if (result === "success") {
      switch (appId) {
        case "Refuse":
          switch (true) {
            case path.includes("/shipsticket/decisioncard"):
              setHeaderText("Выдача судового билета успешно отклонена");
              break;
            case path.includes("dupshipsticket/decisioncard"):
              setHeaderText("Заявление на выдачу дубликата отклонено");
              break;
            case path.includes("reginformationchanges/decisioncard"):
              setHeaderText("Заявление на изменения данных отклонено");
              break;
            case path.includes("smallboatsreg/decisioncard"):
              setHeaderText("Заявление на регистрацию судна отклонено");
              break;
            case path.includes("/techexamination"):
              setHeaderText("Заявление на ТО маломерного судна успешно отклонено");
              break;
            case path.includes("certificates/licenseId/edit"):
              setHeaderText("Удостоверение успешно аннулировано");
              break;
            default:
              break;
          }
          break;
        case "register":
          setHeaderText("Внесение изменений успешно выполнено");
          break;
        default:
          switch (true) {
            case path.includes("smallboatsreg/decisioncard"):
              setHeaderText("Судно успешно зарегистрировано");
              setMessageText("Регистрационный номер");
              break;
            case path.includes("smallboatsreg"):
              setHeaderText("Заявление на регистрацию судна успешно зарегистрировано");
              setMessageText("Регистрационный номер");
              break;
            case path.includes("smallboats"): {
              setHeaderText("Изменения успешно сохранены");
              break;
            }
            case path.includes("transportaccidents"):
              setHeaderText(headerTextExternal);
              setMessageText("");
              break;
            case path.includes("/shipsticket/decisioncard"):
              setMessageText("Номер судового билета");
              setHeaderText("Судовой билет успешно выдан");
              break;
            case path.includes("dupshipsticket/decisioncard"):
              setMessageText("Номер дубликата");
              setHeaderText("Дубликат судового билета успешно выдан");
              break;
            case path.includes("applicationfortraining/edit"):
              setHeaderText("Изменения успешно сохранены");
              // setMessageText([]);
              break;
            case path.includes("listenerTracking/add"):
              setHeaderText("Приказ успешно зарегистрирован");
              setMessageText("Регистрационный номер");
              break;
            case path.includes("record-trained-users/add"):
              setHeaderText("Граждане добавлены");
              setMessageText("Граждане добавлены");
              break;
            case path.includes("record-trained-users/edit"):
              setHeaderText("Изменения");
              setMessageText("Изменения сохранены");
              break;
            case path.includes("knoweledge-test-record/add"):
              setHeaderText("Протокол создан");
              // setMessageText("Номер протокола");
              break;
            case path.includes("knoweledge-test-record/edit"):
              setHeaderText("Изменения");
              setMessageText("Изменения сохранены");
              break;
            case path.includes("certificates/licenseId/edit"):
              setHeaderText("Изменения успешно сохранены");
              break;
            case path.includes("app-knowledge-verification/edit"):
              setHeaderText("Уведомление");
              break;
            default:
              setHeaderText("Заявление успешно зарегистрировано");
              setMessageText("Регистрационный номер");
              break;
          }
          break;
      }
    } else {
      switch (true) {
        case path.includes("smallboats/edit/"): {
          setHeaderText("Ошибка внесения изменений");
          break;
        }
        case path.includes("searchboatcard"):
          setHeaderText(headerTextExternal);
          setMessageText(errorText);
          break;
        case path.includes("transportaccidents"):
          setHeaderText(headerTextExternal);
          setMessageText("");
          break;
        case path.includes("smallboatsreg"):
          setHeaderText(headerTextExternal || "Произошла ошибка");
          setMessageText(errorText);
          break;
        case path.includes("decisioncard"):
          setHeaderText("Произошла ошибка");
          setMessageText(errorText || "Повторите попытку");
          break;
        case path.includes("certificates/licenseId/"):
          setHeaderText("Произошла ошибка");
          setMessageText("Повторите попытку позже");
          break;
        case path.includes("provisioninformation") && !!errorText:
          setHeaderText(headerTextExternal);
          setMessageText(errorText);
          break;
        case path.includes("dupshipsticket") && !!errorText:
          setHeaderText(headerTextExternal);
          setMessageText(errorText);
          break;
        case path.includes("applicationfortraining") && !!errorText:
          setHeaderText(headerTextExternal);
          setMessageText(errorText);
          break;
        case path.includes("app-knowledge-verification") && !!errorText:
          setHeaderText(headerTextExternal);
          setMessageText(errorText);
          break;
        case path.includes("reginformationchanges") && !!errorText:
          setHeaderText(headerTextExternal);
          setMessageText(errorText);
          break;
        case path.includes("smallboats"): {
          setHeaderText(headerTextExternal);
          setMessageText(errorText);
          break;
        }
        default:
          setHeaderText(headerTextExternal || "Произошла ошибка");
          setMessageText(errorText || "Повторите попытку");
          break;
      }
    }
  }, []);

  const handleClose = (e) => {
    if (result === "success") {
      handleCloseApp(e);
    } else {
      setShow(false);
      if (handleCloseExternal) handleCloseExternal();
    }
  };
  return (
    <Modal
      show={show}
      onHide={(e) => handleClose(e)}
      aria-labelledby="contained-modal-title-vcenter"
      centered>
      <Modal.Header
        closeButton
        className={styles["form-header"]}>
        <Modal.Title
          className={styles["form-title"]}
          id="contained-modal-title-vcenter">
          {headerText}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body className={styles["form-body"]}>
        {!!messageText && <div className={styles["label"]}>{messageText}</div>}
        {!!externalJSX && externalJSX}
        {appId && appId !== "register" && appId !== "Refuse" && <div className={styles.app_id}>{appId}</div>}
      </Modal.Body>

      <Modal.Footer className={styles["form-footer"]}>
        <div
          id="close"
          className={styles["close-btn"]}
          onClick={(e) => handleClose(e)}>
          {"Закрыть"}
        </div>
      </Modal.Footer>
    </Modal>
  );
}
